export default "__VITE_ASSET__Dvf3ldGi__"